import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {IPatientInvitations} from '../../entities/PatientInvitations/PatientInvitations.ts';

export class PatientInvitationsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/PatientInvitations`;
    public static apiUrls: {
        postPatientInvitations: string;
        getPatientInvitations: string;
        postAcceptInvitation: string;
        postRefuseInvitation: string;
    } = {
        postPatientInvitations: `${PatientInvitationsApi.baseApiUrl}`,
        getPatientInvitations: `${PatientInvitationsApi.baseApiUrl}`,
        postAcceptInvitation: `${BaseApi.apiUrl}/AcceptInvitation`,
        postRefuseInvitation: `${BaseApi.apiUrl}/RefuseInvitation`,
    };

    public static async postPatientInvitations(data: IPatientInvitations): Promise<IPatientInvitations> {
        return this.sendApiRequest<IPatientInvitations>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postPatientInvitations,
            data: data
        });
    }

    public static async getPatientInvitations(token: string, suppressErrorHandling: boolean = false): Promise<IPatientInvitations> {
        return this.sendApiRequest<IPatientInvitations>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getPatientInvitations}/${token}`,
            suppressGlobalErrorHandling: suppressErrorHandling,
        });
    }

    public static async postAcceptInvitation(variables: string): Promise<void> {
        return this.sendApiRequest({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postAcceptInvitation,
            data: {token: variables}
        });
    }

    public static async postRefuseInvitation(variables: string): Promise<void> {
        return this.sendApiRequest({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postRefuseInvitation,
            data: {token: variables}
        });
    }

    public static async deletePatientInvitation(email: string): Promise<void> {
        return this.sendApiRequest({
            method: HttpMethodEnum.DELETE,
            path: `${this.apiUrls.postPatientInvitations}/${email}`,
        });
    }

    public static async resendPatientInvitation(email: string): Promise<void> {
        return this.sendApiRequest({
            method: HttpMethodEnum.POST,
            path: `${this.baseApiUrl}/Resend/${email}`,
        });
    }

}

